import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetMeals } from "./useGetMeals"
import { MealEntity } from "../../Objects/MealsAndDrinks/MealEntity"
import { useTranslation } from "react-i18next"

export const useRemoveMeal = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetMeals } = useGetMeals()

  const handleRemove = async (meal: MealEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.MEAL.DELETE}/${meal.id}`)

      if (response.success) {
        await handleGetMeals(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
